import React from 'react'
import { useState, useEffect } from 'react'

interface AppPageCompontProps {
	name: string
}

export const AppPageCompont = () => {
	const [count, setCount] = useState(0)

	return <button onClick={() => setCount(count + 1)}> 这是Hook组件 {count}</button>
}



// WEBPACK FOOTER //
// ./src/modules/RouterPage/AppPageCompont.tsx